var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var ResourceTypeController = {
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/resourceTypes" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {SessionResourceTypeDownloadDto[]}
    ******************************************************************************************************/
    GetResourceTypes: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/resourceTypes", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/resourceTypes/{id}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @param {string} id
        * @returns {SessionResourceTypeDownloadDto}
    ******************************************************************************************************/
    GetResourceType: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/resourceTypes/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/resourceTypes" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {SessionResourceTypeUploadDto} dto
        * @returns {SessionResourceTypeDownloadDto}
    ******************************************************************************************************/
    CreateResourceType: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/resourceTypes", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/resourceTypes/{id}" and http method "PUT" to call the back-end.
    
        * @param {string} groupId
        * @param {string} id
        * @param {SessionResourceTypeUploadDto} dto
        * @returns {SessionResourceTypeDownloadDto}
    ******************************************************************************************************/
    UpdateResourceType: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/resourceTypes/{id}", __assign({}, data)),
            method: "PUT",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=ResourceTypeController.js.map